import { Star } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const REVIEWS = [
  { quote: "The cleanest install I've ever seen.", source: "Customer Review" },
  { quote: "My truck sounds insane now.", source: "Customer Review" },
  { quote: "Professional, detailed, and worth every dollar.", source: "Customer Review" },
];

export default function Testimonials() {
  return (
    <section className="relative py-24 sm:py-36" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mb-14 max-w-2xl">
          <Eyebrow>Word On The Street</Eyebrow>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Builds That <span className="text-outline">Speak Loud</span>
          </h2>
        </Reveal>

        <div className="grid gap-4 md:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <Reveal key={i} delay={i * 0.1} className="h-full">
              <figure
                data-testid={`testimonial-${i}`}
                className="flex h-full flex-col rounded-2xl border border-white/10 bg-[#12141B] p-8 transition-colors duration-500 hover:border-[#FF5500]/40"
              >
                <div className="flex gap-1 mb-6">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={15} className="text-[#FF5500]" fill="#FF5500" />
                  ))}
                </div>
                <blockquote className="font-display text-xl sm:text-2xl font-bold tracking-tight leading-snug flex-1">
                  "{r.quote}"
                </blockquote>
                <figcaption className="mt-6 font-tech text-[10px] uppercase tracking-[0.3em] text-white/40">
                  {r.source}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
